import { Schema } from "effect";

export const MessageEmailType = Schema.Literal("gmail", "outlook");
export type MessageEmailType = typeof MessageEmailType.Type;

export const MessageEmailAddressType = Schema.Literal(
  "from",
  "to",
  "cc",
  "bcc",
);
export type MessageEmailAddressType = typeof MessageEmailAddressType.Type;
